import { getQuickList } from "services/sosInventoryService/sosApi";

import { OBJECT_TYPES } from "appConstants";

export async function fetchClasses(query) {
  const response = await getQuickList(OBJECT_TYPES.CLASS.fullString, {
    inTransaction: true,
    query,
  });
  if (response) {
    return response.data.map((rec) => ({ ...rec, name: rec.fullName }));
  }
  return [];
}
